import React, { useState } from "react";
import { getApplicationKeyMap } from "react-hotkeys";
import { Modal, Icon, Button, Table } from "semantic-ui-react";

const HotkeyInfo = () => {
  const [open, setOpen] = useState(false);
  const keyMap = getApplicationKeyMap();
  return (
    <Modal
      open={open}
      closeIcon
      onClose={() => setOpen(false)}
      trigger={<Trigger onClick={() => setOpen(true)} />}
    >
      <Modal.Header>Hotkeys</Modal.Header>
      <Modal.Content>
        <Table celled>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Function</Table.HeaderCell>
              <Table.HeaderCell>Key</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {Object.keys(keyMap).map((key, i) => (
              <Table.Row key={i}>
                <Table.Cell>{keyMap[key].name}</Table.Cell>
                <Table.Cell>{`"${keyMap[key].sequences[0].sequence}"`}</Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      </Modal.Content>
    </Modal>
  );
};

const Trigger = ({ onClick }) => (
  <Button size="mini" floated="right" basic onClick={onClick}>
    <Icon name="keyboard" />
    Hotkeys
  </Button>
);

export default HotkeyInfo;
